import { render, staticRenderFns } from "./square-pics.vue?vue&type=template&id=6ddcfaac&"
import script from "./square-pics.vue?vue&type=script&lang=js&"
export * from "./square-pics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports